import { Helmet } from 'react-helmet-async';

// @mui
import { Container, Typography, Box, Stack, CircularProgress } from '@mui/material';

// components
import PieChart from '../components/chart/PieChart';
import OverViewChart from '../components/chart/OverViewChart';
import FeaturedChart from '../components/chart/FeaturedChart';

import Attendance from '../components/reusableTables/index';

import useUsers from '../hooks/useUsers';

export default function DashboardAppPage() {
  const { parishReport, parishReportError, parishReportLoader, attendance, attendanceLoader, attendanceError } = useUsers();

  const countGender = (attendanceData) => {
    const maleCount = attendanceData.filter(member => member.gender === "Male").length;
    const femaleCount = attendanceData.filter(member => member.gender === "Female").length;

    return { male: maleCount, female: femaleCount };
  };

  return (
    <>
      <Helmet>
        <title> Dashboard | CaaS MS </title>
      </Helmet>

      {parishReportLoader ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', allignItems: 'center', height: '100%' }}>
          <CircularProgress sx={{ color: '#000080' }} />
        </Box>
      ) : parishReportError ? (
        <Typography sx={{ mb: 2, color: '#A1A1A1', fontSize: '30px', fontWeight: 900, textAlign: 'center' }}>
          {parishReportError}
        </Typography>
      ) : (
        <Container maxWidth="xl">
          <Box>
            <Typography fontSize={25} fontWeight={700} color="#11142d">
              Dashboard
            </Typography>

            <Box mt="20px" display="flex" flexWrap="wrap" gap={4}>
              <PieChart
                // title="New Members (Month)"
                title="New Members for this Month"
                value={`${parishReport.newMemberData.currentMonthCount}`}
                series={[
                  Math.round(parishReport.newMemberData.currentMonthPercentageMale),
                  Math.round(parishReport.newMemberData.currentMonthPercentageFemale),
                ]}
                colors={['#000080', '#7EA7F4']}
              />
              <PieChart
                title="Present in Attendance"
                value={`${attendance.length}`}
                series={[countGender(attendance).male, countGender(attendance).female]}
                colors={['#006633', '#90BC61']}
              />
              <PieChart
                title="Total Members"
                value={`${parishReport.newMemberData.totalMemberCount}`}
                series={[
                  // convert to integer value
                  Math.round(parishReport.newMemberData.totalMemberPercentageMale),
                  Math.round(parishReport.newMemberData.totalMemberPercentgaeFemale),
                ]}
                colors={['#8B4000', '#FF9933']}
              // colors={['#475ae8', '#e4e8ef']}
              />
            </Box>

            <Stack mt="25px" width="100%" gap={3} direction={{ xs: 'column', lg: 'row' }}>
              <OverViewChart
                aspect={2}
                attendancePercentage={parishReport.attendanceStatData.attendancePercentage}
                attendanceStatData={parishReport.attendanceStatData}
              />
              <FeaturedChart parishReport={parishReport} />
            </Stack>

            <Box
              // p={3}
              bgcolor="#fcfcfc"
              borderRadius="15px"
              boxShadow="2px 4px 10px 1px rgba(201,201,201,0.47)"
              mt="20px"
            >
              <Attendance attendance={attendance} attendanceError={attendanceError} />
            </Box>
          </Box>
        </Container>
      )}
    </>
  );
}
